import { getAccountNumber } from '@interfaces/account';
import type { AccountAllocationGridAccount } from './types';

export type AccountColumnLabel = {
  ownerLine?: string;
  accountType?: string;
  accountNumber: string;
};

export const accountColumnLabel = (
  account: AccountAllocationGridAccount['subAccount']['account'],
  t: (key: string) => string,
): AccountColumnLabel => {
  const owner =
    [account.user.firstName, account.user.lastName].filter(Boolean).join(' ') ||
    account.user.entityName;
  const accountType = account.type ? t(`accountTypes:${account.type}`) : '';

  return {
    ownerLine: accountType && owner ? `${owner}'s` : undefined,
    accountType: accountType || undefined,
    accountNumber: getAccountNumber({
      id: account.id,
      custodianAccountNumber: account.custodianAccountNumber,
    }),
  };
};

export const accountColumnLabelLines = ({
  ownerLine,
  accountType,
  accountNumber,
}: AccountColumnLabel) =>
  [ownerLine, accountType, accountNumber].filter((line): line is string =>
    Boolean(line),
  );
